require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-retail-pendulum-developing-a-balanced-e-commerce-strategy.json") })
        }
      }, "path---blog-the-retail-pendulum-developing-a-balanced-e-commerce-strategy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-retail-pendulum-developing-a-balanced-e-commerce-strategy!./.cache/json/blog-the-retail-pendulum-developing-a-balanced-e-commerce-strategy.json
// module id = 503
// module chunks = 231608221292675